import { DateTime } from 'luxon';
import * as yup from 'yup';

export const validationSchema = yup
  .object()
  .shape({
    dataOrigineFamigliaConvivenza: yup.date().nullable(),
    editDataControl: yup.object().shape({
      dateValidity: yup
        .date()
        .nullable()
        .typeError('Data non valida')
        .required('Campo obbligatorio'),
      // flag: yup.string().required('Campo obbligatorio'), campo commentato
    }),
    cohabitationData: yup.object().shape({
      requestDate: yup
        .date()
        .nullable()
        .typeError('Data non valida')
        .required('Campo obbligatorio')
        .max(
          DateTime.now().endOf('day').toJSDate(),
          'Non è possibile inserire una data superiore alla data odierna'
        ),
      municipality: yup.object().shape({}).nullable().required('Campo obbligatorio'),
      stipulationDate: yup
        .date()
        .nullable()
        .typeError('Data non valida')
        .max(
          DateTime.now().endOf('day').toJSDate(),
          'Non è possibile inserire una data superiore alla data odierna'
        ),
      notifyDate: yup
        .date()
        .nullable()
        .typeError('Data non valida')
        .max(
          DateTime.now().endOf('day').toJSDate(),
          'Non è possibile inserire una data superiore alla data odierna'
        )
        .when('stipulationDate', {
          is: (stipulationDate: Date | null) => stipulationDate !== null,
          then: yup.date().required('Data di notifica obbligatoria se presente la data di stipula'),
        }),
      list: yup
        .string()
        .nullable()
        .when(['stipulationDate', 'notifyDate'], {
          is: (stipulationDate: Date | null, notifyDate: Date | null) =>
            stipulationDate !== null || notifyDate !== null,
          then: yup
            .string()
            .required(
              'Tipo di professionista obbligatorio se presente la data di stipula o notifica'
            ),
        }),
      professionist: yup
        .string()
        .nullable()
        .when(['stipulationDate', 'notifyDate'], {
          is: (stipulationDate: Date | null, notifyDate: Date | null) =>
            stipulationDate !== null || notifyDate !== null,
          then: yup
            .string()
            .required(
              'Nome del professionista obbligatorio se presente la data di stipula o notifica'
            ),
        }),
    }),
  })
  .test((values) => {
    const dateValidity = values?.editDataControl?.dateValidity
      ? DateTime.fromJSDate(values.editDataControl.dateValidity)
      : null;

    const dataCostituzioneFamigliaConvivenza = values?.dataOrigineFamigliaConvivenza
      ? DateTime.fromJSDate(values?.dataOrigineFamigliaConvivenza)
      : null;

    if (dataCostituzioneFamigliaConvivenza && dateValidity) {
      if (dataCostituzioneFamigliaConvivenza >= dateValidity) {
        return new yup.ValidationError(
          'Data di validità deve essere successiva alla data di origine della famiglia',
          undefined,
          'editDataControl.dateValidity'
        );
      }
    }

    return true;
  });
